import { HttpInterceptorFn } from '@angular/common/http';

import { getUserLocale } from '@/app/shared/utils/user-locale';

export const apiInterceptor: HttpInterceptorFn = (request, next) => {
  const selectedLang = getUserLocale();

  const modifiedRequest = request.clone({
    setHeaders: {
      'Accept-Language': selectedLang,
    },
  });

  return next(modifiedRequest);
};
